const n = "_wrapper_1wwn6_1", t = "_contentWrapper_1wwn6_13", e = "_contactSection_1wwn6_19", c = "_link_1wwn6_24", _ = "_name_1wwn6_28", a = "_addressLine_1wwn6_31", o = {
  wrapper: n,
  contentWrapper: t,
  contactSection: e,
  link: c,
  name: _,
  addressLine: a
};
export {
  a as addressLine,
  e as contactSection,
  t as contentWrapper,
  o as default,
  c as link,
  _ as name,
  n as wrapper
};
